<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox
        @query="query"
        v-model:inputValue="mydata.form.search"
        placeholder="请输入关键字（省份/年份/分数）"
      ></inputBox>
    </div>

    <!-- 内容部分 -->
    <div class="box-content">
      <div class="box-left">
        <!--  -->
        <div class="box-online1">
          <!-- 学科筛选按钮 -->
          <subjectButton2
            :filterButton="mydata.filterButton1"
            style="margin-bottom: 10px"
            v-model:myModelValue="mydata.form.area_id"
            textWidth="44px"
            :allBtnShow="false"
          ></subjectButton2>
          <subjectButton2
            :filterButton="mydata.filterButton2"
            style="margin-bottom: 10px"
            v-model:myModelValue="mydata.form.year_id"
            textWidth="44px"
            :allBtnShow="false"
          ></subjectButton2>
          <subjectButton2
            :filterButton="mydata.filterButton3"
            style="margin-bottom: 10px"
            v-model:myModelValue="mydata.form.class_id"
            textWidth="70px"
          ></subjectButton2>
          <subjectButton2
            :filterButton="mydata.filterButton4"
            v-model:myModelValue="mydata.form.batch_id"
            textWidth="70px"
          ></subjectButton2>
        </div>
        <!-- 主题内容 -->
        <div class="left-main">
          <el-table
            stripe
            :data="mydata.tableData"
            border
            style="width: 100%"
            header-row-class-name="my-table-header"
            row-class-name="my-table-row"
          >
            <el-table-column align="center" prop="area_name" label="地区" width="100" />
            <el-table-column align="center" prop="year_name" label="年份" width="100"  />
            <el-table-column align="center" prop="class_name" label="考生类别" width="160" >
            </el-table-column>
            <el-table-column align="center" prop="batch_name" label="批次" width="180" >
              <template #default="scope">
                <span v-if="scope.row.class_descr"
                  >{{ scope.row.batch_name }} -
                  {{ scope.row.class_descr }}</span
                >
                <span v-else>{{ scope.row.batch_name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="score" label="分数线" width="120" >
            </el-table-column>
            <el-table-column align="center" prop="ranking" label="位次" width="130" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="professional_score"
              label="专业分"
              width="120" 
            >
            </el-table-column>
            <!-- <el-table-column align="center" prop="three" label="录取率"> -->
            <!-- </el-table-column> -->
            <!-- width="160"最后一列不要设置width了，全部宽度减去其他列的宽度就是它的宽度了，如果最后一列也设置了固定宽度，那么线条会出现问题 -->
          </el-table>
        </div>
        <!--分页 -->
        <div class="gl-pagination">
          <el-pagination
            v-model:currentPage="mydata.pageObj.currentPage"
            v-model:page-size="mydata.pageObj.pageSize"
            :total="mydata.pageObj.total"
            layout="prev, pager, next"
        pager-count="4"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
      <!-- 右侧推荐区域 -->
      <div class="box-right">
        <!-- 必备好书 -->
        <!-- <rightCardBook></rightCardBook> -->
        <!-- 超值推荐 -->
        <rightCardGreatValue title="超值推荐"></rightCardGreatValue>
      </div>
    </div>
  </div>
</template>

//  <script>
// // 缓存组件
// import { defineComponent } from "vue"
// export default defineComponent({
//   name: 'fractionBar'
// });
//
</script>


<script setup>
// import { Calendar } from "@element-plus/icons-vue";
// import { View } from "@element-plus/icons-vue";
// import { Download } from "@element-plus/icons-vue";
// import { Menu } from "@element-plus/icons-vue";
// import { Lock } from "@element-plus/icons-vue";
// 必备好书
// import rightCardBook from "@/components/rightCardBook/index.vue";
// 超值推荐
import rightCardGreatValue from "@/components/rightCardGreatValue/index2.vue";

import { useRouter } from "vue-router";

import { reactive, watch } from "vue";
// import { Star } from "@element-plus/icons-vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
// import thematicCards from "@/components/thematicCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";
import subjectButton2 from "@/components/subjectButton/index2.vue";

import column from "@/components/column/index.vue";

import rowBookCards from "@/components/rowBookCards/index.vue";
import {
  fractionList,
  fractionArea,
  fractionYear,
  fractionClass,
  fractionBatch,
} from "@/api/home/index.js";

const router = useRouter();

const mydata = reactive({
  activeName: "first",

  tableData: [],
  //筛选按钮
  filterButton1: {
    title: "地区",
    filter: [],
  },
  filterButton2: {
    title: "年份",
    filter: [],
  },
  filterButton3: {
    title: "考试类别",
    filter: [],
  },
  filterButton4: {
    title: "录取批次",
    filter: [],
  },
  form: {
    area_id: "",
    year_id: "",
    search: "",
    class_id: "",
    batch_id: "",
  },
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {},
  bol: false,
  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 10, // 每页条数
    total: 0, // 总的条数
  },
});

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  getList();
}

function objectSpanMethod({ row, column, rowIndex, columnIndex }) {
  return;
  // console.log(
  //   "row",
  //   row,
  //   "column",
  //   column,
  //   "rowIndex",
  //   rowIndex,
  //   "columnIndex",
  //   columnIndex
  // );
  let merge = JSON.parse(row.merge);
  // 省份
  if (columnIndex === 0) {
    return {
      rowspan: 1, // 写死
      colspan: 1,
    };
  }
  // 年份
  if (columnIndex === 1) {
    return {
      rowspan: 1, // 写死
      colspan: 1,
    };
  }
  // 如果第一批第二批第三批整体合并
  if (merge.one_arts === 6) {
    // 第一批-文
    if (columnIndex === 2) {
      return {
        rowspan: 1, // 写死
        colspan: merge.one_arts,
      };
    }
    // 第一批-理
    if (columnIndex === 3) {
      return {
        rowspan: 1, // 写死
        colspan: 0,
      };
    }
    // 第二批-文
    if (columnIndex === 4) {
      return {
        rowspan: 1, // 写死
        colspan: 0,
      };
    }
    // 第二批-理
    if (columnIndex === 5) {
      return {
        rowspan: 1, // 写死
        colspan: 0,
      };
    }
    // 第三批-文
    if (columnIndex === 6) {
      return {
        rowspan: 1, // 写死
        colspan: 0,
      };
    }
    // 第三批-理
    if (columnIndex === 7) {
      return {
        rowspan: 1, // 写死
        colspan: 0,
      };
    }
  }
  // 如果第一批第二批第三批不整体合并
  if (merge.one_arts !== 6) {
    // 第一批-文
    if (columnIndex === 2) {
      return {
        rowspan: 1, // 写死
        colspan: merge.one_arts,
      };
    }
    // 第一批-理
    if (columnIndex === 3) {
      return {
        rowspan: 1, // 写死
        colspan: 2 - merge.one_arts,
      };
    }
    // 第二批-文
    if (columnIndex === 4) {
      return {
        rowspan: 1, // 写死
        colspan: merge.two_arts,
      };
    }
    // 第二批-理
    if (columnIndex === 5) {
      return {
        rowspan: 1, // 写死
        colspan: 2 - merge.two_arts,
      };
    }
    // 第三批-文
    if (columnIndex === 6) {
      return {
        rowspan: 1, // 写死
        colspan: merge.three_arts,
      };
    }
    // 第三批-理
    if (columnIndex === 7) {
      return {
        rowspan: 1, // 写死
        colspan: 2 - merge.three_arts,
      };
    }
  }
  // 其他的列不用合并直接展示
  return {
    rowspan: 1, // 写死
    colspan: 1,
  };
}

async function getfractionArea() {
  let res = await fractionArea();
  mydata.filterButton1.filter = res.data.map((item) => {
    return {
      label: item.name,
      name: item.id,
    };
  });
  // 默认选中第一个
  mydata.form.area_id = mydata.filterButton1.filter[0].name;
}

async function getfractionYear() {
  let res = await fractionYear();
  mydata.filterButton2.filter = res.data.map((item) => {
    return {
      label: item.name,
      name: item.id,
    };
  });
  // 默认选中第一个
  mydata.form.year_id = mydata.filterButton2.filter[0]?.name;
}

function getfractionClass() {
  fractionClass({
    year_id: mydata.form.year_id,
    area_id: mydata.form.area_id,
  }).then((res) => {
    mydata.filterButton3.filter = res.data.map((item) => {
      return {
        label: item.name,
        name: item.id,
      };
    });
  });
}

function getfractionBatch() {
  fractionBatch({
    year_id: mydata.form.year_id,
    area_id: mydata.form.area_id,
  }).then((res) => {
    mydata.filterButton4.filter = res.data.map((item) => {
      return {
        label: item.name,
        name: item.id,
      };
    });
  });
}
getfractionArea();
getfractionYear();
// 并发
// Promise.all([getfractionArea(), getfractionYear()]).then((res) => {
//   getfractionClass();
//   getfractionBatch();
// });

watch(
  () => {
    return [mydata.form.area_id, mydata.form.year_id];
  },
  (n, o) => {
    // console.log("n", n);
    if (mydata.form.area_id && mydata.form.year_id) {
      // console.log(123);
      mydata.bol = true;
      mydata.form.class_id = "";
      mydata.form.batch_id = "";
      mydata.filterButton3.filter = [];
      mydata.filterButton4.filter = [];
      getfractionClass();
      getfractionBatch();
      getList();
    }
  }
);

watch(
  () => {
    return [mydata.form.class_id, mydata.form.batch_id];
  },
  (n, o) => {
    // console.log("n2", n);
    // if (mydata.form.class_id || mydata.form.batch_id) {
    // console.log(456);
    // console.log(mydata.bol)
    if (mydata.bol === false) {
      getList();
    }
    // }
  }
);

// 输入框内容改变事件
function query(dict, val) {
  // 分页变成第一页
  mydata.pageObj.currentPage = 1;
  // 赋值
  mydata.form.search = val;
  // 查询
  getList();
}

// 查询分数列表
function getList() {
  fractionList(
    {
      ...mydata.form,
      page: String(mydata.pageObj.currentPage),
      psize: String(mydata.pageObj.pageSize),
    },
    mydata.userInfo.jwt
  ).then((res) => {
    // console.log(res);
    mydata.tableData = res.data.list;
    mydata.bol = false;

    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// getList();

//必备好书详情
function fn() {
  router.push({
    path: "/layout/list/booksDetails",
  });
}
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
    }
    //////按钮消失一个
    :deep(.el-button.el-button--primary.box2) {
      display: none;
    }
  }
 

  //////内容部分
  .box-content {
    // width: 1200px;
    // border: 1px solid red;
    margin: 0 auto;
    // margin-top: 21px;
    // margin-bottom:16px;
    // display: flex;
    // justify-content: space-between;

    /////左边内容部分
    .box-left {
      // width: 860px;
      // border: 1px dashed rgb(102, 255, 0);
      background-color: #f9f9f9;
      // margin:0 auto;

      //////搜索组件 和 按钮组件
      .box-online1 {
        background-color: #ffffff;
        margin: 0 auto;
        margin-top: 16px;
        margin-bottom: 16px;
        padding-top: 16px;
        padding-bottom: 16px;
        overflow: hidden;
        // border: 1px solid red;

        
      }
      //左边————主题内容
      .left-main {
        width: 100%;
        // height: 818px;
        // border: 1px solid red;
        // border-radius: 8px;
        padding: 16px;
        background-color: #ffffff;
      }
    }

    ////右边
    .box-right {
      margin-top: 16px;
    }
  }
}

/** 表格头部 */
:deep(.my-table-header) {
  > th {
    background: #009de0 !important;
    border-color: #009de0 !important;
    border-color: #f9f9f9 !important;
    height: 45px;
     border:none;
    > .cell {
      color: #f9f9f9;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1px;
    }
  }
}

/** 表格身体 */
:deep(.my-table-row) {
  height: 20px;
  > td {
    border-color: #009de0 !important;
   
    > .cell {
      color: #333333;
      font-size: 13px;
      font-weight: 400;
      
    }
  }
}

/** 表格边线 */
:deep(.el-table__border-left-patch) {
  background-color: #009de0 !important;
}
:deep(.el-table--border .el-table__inner-wrapper:before) {
  background-color: #009de0 !important;
}
:deep(.el-table--border .el-table__inner-wrapper:after) {
  background-color: #009de0 !important;
}
:deep(.el-table--border:after) {
  background-color: #009de0 !important;
}
:deep(.el-table--border:before) {
  background-color: #009de0 !important;
}

/* 2n表格背景 */
:deep(
    .el-table--striped
      .el-table__body
      tr.el-table__row--striped
      td.el-table__cell
  ) {
  background-color: #98e0ff;
}

:deep(.el-table__inner-wrapper) {
  overflow-x: auto;

  /* 针对webkit内核浏览器 */
  ::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
  }

  /* 针对Firefox */
  scrollbar-width: none; /* Firefox中隐藏滚动条 */

  /* 针对IE和Edge */
  -ms-overflow-style: none; /* IE和Edge中隐藏滚动条 */
}
</style>
